import { walkAncestors } from "../walk-ancestors.js";
//#region src/dom/locale/find-nearest-lang.ts
function getElementLang(node) {
	const fromAttribute = node.getAttribute("lang")?.trim();
	if (fromAttribute) return fromAttribute;
	if ("lang" in node && typeof node.lang === "string") {
		const fromProperty = node.lang.trim();
		if (fromProperty) return fromProperty;
	}
}
/** First non-empty `lang` on `start` or an ancestor (HTML language inheritance). */
function findNearestLang(start) {
	return walkAncestors(start, getElementLang);
}
//#endregion
export { findNearestLang };

//# sourceMappingURL=find-nearest-lang.js.map